import TerciaryButton from "@/components/buttons/terciary-button/TerciaryButton";
import { Pill } from "@/components/pill/Pill";
import { useDate } from "@/hooks/use-date/useDate";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import type { IAnswer } from "@/types/types";
import type { FC } from "react";

interface EditableAnswerProps {
  item: IAnswer;
  handleOnOpenAndEdit?: () => void;
  handleOnOpen?: () => void;
}

export const EditableAnswer: FC<EditableAnswerProps> = ({
  item,
  handleOnOpen = () => {},
  handleOnOpenAndEdit = () => {},
}) => {
  const translation = useTranslate();
  const { formatDate } = useDate();

  return (
    <div className="grid grid-rows-[1fr_auto] gap-2 w-full">
      <div role="button" onClick={handleOnOpen} className="flex flex-col gap-2">
        <div className="flex justify-between items-center">
          <div className="flex gap-1">
            <Pill
              icon={"check"}
              label={translation("ready")}
              className="bg-[#ADE1C7]"
              iconClassName="size-3"
            />
            <Pill
              icon={"comment"}
              label={item.status}
              className="bg-ib-gray-lightest text-nowrap"
              iconClassName="size-3"
            />
          </div>
          <time className="text-sm text-ib-gray-main">
            {formatDate(item.updatedAt?.toString())}
          </time>
        </div>
        <div className="flex w-full items-center">
          {item.comment ? (
            <p
              className="text-md text-ib-gray-darkest"
              style={{
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 1,
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {item.comment}
            </p>
          ) : (
            <div className="w-full border border-dashed border-ib-gray-borders">
              <p className="text-ib-gray-dark-2 text-center">
                {translation("addCommentOrImages")}
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 items-center">
        <div role="button" onClick={handleOnOpen}>
          <Pill
            icon={"images"}
            label={item.images?.length}
            className="bg-ib-gray-lightest"
            iconClassName="size-3"
          />
        </div>
        <div className="relative flex h-full w-full ">
          <div className="absolute z-10 top-0 bottom-0 right-0 flex justify-end items-center ">
            <TerciaryButton
              onClick={handleOnOpenAndEdit}
              icon="pencil"
              label={translation("edit")}
              colour={"red"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
